// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageCoverFragmentDoc } from '../imageCover.fragment.generated';
import { ComponentTitleFragmentDoc } from './content/ContentTitle.fragment.generated';
export const ComponentBannerSkinnyFragmentDoc = gql`
    fragment componentBannerSkinny on ComponentBannerSkinny {
  useBackgroundImage
  backgroundImage {
    ...imageCover
  }
  backgroundColor
  backgroundGraphic
  title {
    ...componentTitle
  }
}
    ${ImageCoverFragmentDoc}
${ComponentTitleFragmentDoc}`;